import React, { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import classNames from 'classnames/bind';
import PageLink from 'components/PageLink/PageLink';
import TextOrHtml from 'components/TextOrHtml/TextOrHtml';
import styles from './FooterBlock.module.scss';

interface Props {
  block: any;
  blockFriendlyUrls: any
}

const FooterBlock = ({ block,blockFriendlyUrls }: Props) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const isLargeScreen = useMediaQuery({ query: '(min-width: 768px)' });

  useEffect(() => {
    isLargeScreen && setIsOpen(true);
  }, [isLargeScreen]);

  return (
    
    <div
      className={styles.block}
      onClick={() => !isLargeScreen && setIsOpen(!isOpen)}
    >
      
      <h3 className={classNames(styles.heading, isOpen && styles.active)}>
        {block?.Heading} <i className={classNames(isOpen && styles.active)} />
      </h3>
      {isOpen && (
        <div className={styles.content}>
          <div className={styles.links}>
            {(block.LinkItems || []).map((link: any, index: number) => (
           blockFriendlyUrls[block?.Heading] !==undefined &&
           <PageLink
                key={index}
                url={(blockFriendlyUrls && blockFriendlyUrls[block?.Heading]) ? blockFriendlyUrls[block?.Heading][index] : link.href}
                text={link.Text}
                className={styles.link}
              />
              
 ))}
          </div>
          {block.BottomTextArea && (
            <TextOrHtml
              value={block.BottomTextArea}
              className={styles.openingHours}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default FooterBlock;
